<mat-card role="region" aria-labelledby="request-time-off-title">
    <mat-card-title>
        <h2 id="request-time-off-title" appLocalizationPopupDirective [localizationCode]="'RequestTimeOff'">{{ 'RequestTimeOff' | translate: {Default: "Request Time Off"} }}</h2>
    </mat-card-title>

    <mat-card-content>
        <p class="sr-only" id="request-time-off-grid-description">
            {{ 'RequestTimeOff' | translate: {Default: "Request Time Off"} }}
            {{ 'RequestTimeOff-TimeOffType' | translate: {Default: "Time Off Type"} }},
            {{ 'RequestTimeOff-AvailableHours' | translate: {Default: "Available Hours"} }},
            {{ 'RequestTimeOff-FutureHoursScheduled' | translate: {Default: "Future Hours Scheduled"} }},
            {{ 'RequestTimeOff-HoursTaken' | translate: {Default: "Hours Taken"} }}.
        </p>
        <kendo-grid
            [navigable]="true"
            [data]="gridDataResult"
            [loading]="isLoading"
            aria-labelledby="request-time-off-title"
            aria-describedby="request-time-off-grid-description"
        >
            <kendo-grid-column field="timeOffPolicy" width="150">
                <ng-template kendoGridHeaderTemplate>
                    <div appLocalizationPopupDirective [localizationCode]="'RequestTimeOff-TimeOffType'">
                        {{ 'RequestTimeOff-TimeOffType' | translate: {Default: "Time Off Type"} }}
                    </div>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="grid-cell-vertical">
                        {{dataItem.timeOffType.name}}
                    </div>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="availableHours" width="150">
                <ng-template kendoGridHeaderTemplate>
                    <div appLocalizationPopupDirective [localizationCode]="'RequestTimeOff-AvailableHours'">
                        {{ 'RequestTimeOff-AvailableHours' | translate: {Default: "Available Hours"} }}
                    </div>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="grid-cell-vertical">
                        {{dataItem.availableHours  | number:'1.0-1'}}
                    </div>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="futureHoursScheduled" width="180">
                <ng-template kendoGridHeaderTemplate>
                    <div appLocalizationPopupDirective [localizationCode]="'RequestTimeOff-FutureHoursScheduled'">
                        {{ 'RequestTimeOff-FutureHoursScheduled' | translate: {Default: "Future Hours Scheduled"} }}
                    </div>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="grid-cell-vertical">
                        {{dataItem.futureHoursScheduled  | number:'1.0-1'}}
                    </div>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="hoursTaken" width="130">
                <ng-template kendoGridHeaderTemplate>
                    <div appLocalizationPopupDirective [localizationCode]="'RequestTimeOff-HoursTaken'">
                        {{ 'RequestTimeOff-HoursTaken' | translate: {Default: "Hours Taken"} }}
                    </div>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="grid-cell-vertical">
                        {{dataItem.hoursTaken  | number:'1.0-1'}}
                    </div>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="actionButtons" title="" width="160">
                <ng-template kendoGridHeaderTemplate>
                    <span class="sr-only">{{ 'timeOffLeaveTypeRequestTimeOff' | translate: {Default: "Request Time Off"} }}</span>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="grid-cell-vertical">
                        <button mat-stroked-button setColor="primaryColour" color="primary" type="button" appPreventDoubleClick (throttledClick)="openDialog(dataItem.timeOffType.id)" [attr.aria-label]="('timeOffLeaveTypeRequestTimeOff' | translate: {Default: 'Request Time Off'}) + ' ' + dataItem.timeOffType.name + '. ' + (dataItem.availableHours  | number:'1.0-1') + ' hours available.'">
                            {{ 'timeOffLeaveTypeRequestTimeOff' | translate: {Default: "Request Time Off"} }}
                        </button>
                    </div>
                </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="actionButtons" title="" width="180">
                <ng-template kendoGridHeaderTemplate>
                    <span class="sr-only">{{ 'ViewFutureSchedule' | translate: {Default: "View Future Schedule"} }}</span>
                </ng-template>
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="grid-cell-vertical" *ngIf="dataItem?.timeOffPolicy?.showAccrualSchedule === true">
                        <button mat-stroked-button setColor="primaryColour" color="primary" type="button" appPreventDoubleClick (throttledClick)="openFutureScheduleDialog(dataItem)" [attr.aria-label]="('ViewFutureSchedule' | translate: {Default: 'View Future Schedule'}) + ' ' + dataItem.timeOffType.name">
                            {{ 'ViewFutureSchedule' | translate: {Default: "View Future Schedule"} }}
                        </button>
                    </div>
                </ng-template>
            </kendo-grid-column>

            <ng-template kendoGridNoRecordsTemplate>
                <div appLocalizationPopupDirective [localizationCode]="'NoPoliciesAssigned'" role="status" aria-live="polite">
                    {{ 'NoPoliciesAssigned' | translate: {Default: "No Policies Assigned"} }}
                </div>
             </ng-template>

             <kendo-grid-messages 
                [noRecords]="isLoading ? '' : translate.instant('Grid-NoRecordsAvailable')"
                [pagerItemsPerPage]="translate.instant('Grid-Pager-ItemsPerPage')" 
                [pagerItems]="translate.instant('Grid-Pager-Items')"
                [pagerOf]="translate.instant('Grid-Pager-Of')"
            ></kendo-grid-messages>
        </kendo-grid>
    </mat-card-content>
</mat-card>
